<template>
  <span
    v-b-tooltip.hover
    class="keyboard-shortcut"
    :title="tooltip"
  >
    <feather-icon
      icon="CommandIcon"
      size="16"
      class="shortcut-icon"
    />
    <span class="shortcut-key">{{ shortcut }}</span>
  </span>
</template>

<script>
export default {
  name: 'KeyboardShortcut',
  props: {
    shortcut: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown)
  },
  methods: {
    handleKeyDown(e) {
      // Check if Ctrl key is pressed with the specified shortcut key
      if (e.ctrlKey && e.key.toLowerCase() === this.shortcut.toLowerCase()) {
        e.preventDefault()
        this.$emit('shortcut')
      }
    },
  },
}
</script>

<style scoped>
.keyboard-shortcut {
  display: inline-flex;
  align-items: center;
  background-color: rgba(115, 103, 240, 0.1);
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid rgba(115, 103, 240, 0.2);
  cursor: help;
  transition: all 0.2s ease;
}

.keyboard-shortcut:hover {
  background-color: rgba(115, 103, 240, 0.2);
}

.shortcut-icon {
  color: #7367f0;
  margin-right: 4px;
}

.shortcut-key {
  font-size: 0.8rem;
  font-weight: 600;
  color: #7367f0;
}
</style>
